<template>
  <div class="login-container">
    <h2 class="mt-2">請輸入密碼</h2>
    <input
      type="password"
      v-model="password"
      placeholder="請輸入密碼"
      class="form-control mt-3"
      @keyup.enter="handleLogin"
    />
    <button @click="handleLogin" class="btn btn-primary mt-4 mb-2 w-100">
      登入
    </button>
    <p v-if="errorMsg" class="text-danger mt-2">{{ errorMsg }}</p>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router"; // 1. 引入路由 hook

const router = useRouter(); // 2. 建立路由實例
const password = ref("");
const errorMsg = ref("");

// 3. 改成 const 宣告函式
const handleLogin = async () => {
  // 4. 改用 .value 存取變數
  errorMsg.value = "";

  try {
    const response = await fetch(
      "https://baofengbooks.com/s_api/public/api/admin-login",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          password: password.value,
        }),
      }
    );

    const result = await response.json();

    if (response.ok) {
      sessionStorage.setItem("token", result.token);
      sessionStorage.setItem("isAuthenticated", "true");

      alert("登入成功！");
      router.push("/"); // 5. 使用 router 實例跳轉
    } else {
      errorMsg.value = result.message || "密碼錯誤";
      password.value = ""; // 清空密碼
    }
  } catch (error) {
    console.error(error);
    errorMsg.value = "無法連線到伺服器";
  }
};
</script>

<style scoped>
.login-container {
  max-width: 254px;
  margin: 0 auto;
}
input {
  width: 100%;
  padding: 8px;
}
</style>
